<template>
    <b-container fluid>
        <v-draggable class="list-group" tag="ul" v-model="updatedList">
            <transition-group type="transition" :name="'flip-list'">
                <slot/>
            </transition-group>
        </v-draggable>
    </b-container>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        components: { 'v-draggable': draggable },

        props: { list: { type: Array, required: true } },

        data() {
            return { updatedList: null };
        },

        watch: {
            updatedList: function (newValue) {
                if (JSON.stringify(newValue) === JSON.stringify(this.list)) {
                    return;
                }
                this.$emit('update', newValue);
            },
            list: {
                handler: function (newValue) {
                    this.updatedList = JSON.parse(JSON.stringify(newValue));
                },
                immediate: true
            }
        }
    };
</script>

<style scoped lang="scss">
    .flip-list-move {
        transition: transform 0.2s;
    }
</style>
